import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'showActive', standalone: false })
export class ShowActivePipe implements PipeTransform {
  transform(items: any, key?: any, filterFlag?: any): any {
    if (!items) {
      return [];
    }
    if (!key || !filterFlag) {
      return items;
    }

    return items.filter((item) => item[key]);
  }
}
